let loaded = false;

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (loaded || window.Razorpay) {
      loaded = true;
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => {
      loaded = true;
      resolve(true);
    };
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
